import { Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
@Injectable({
  providedIn: 'root'
})
export class canDeactivateModalGuard {
  authkey = '';
  token: any;
  constructor(private modalService: NgbModal) { }
  canDeactivate(): boolean {
    if (this.modalService.hasOpenModals()) {
      this.modalService.dismissAll();
      // return false;
    } else
      return true;
  }
}
